"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusCard = void 0;
const react_1 = __importStar(require("react"));
const Badge_1 = __importDefault(require("react-bootstrap/Badge"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const BookingStatus_1 = require("../../../models/BookingStatus");
const StatusCard = (props) => {
    var _a;
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    return (react_1.default.createElement(Card_1.default, { className: "status-card " + ((_a = props.className) !== null && _a !== void 0 ? _a : "") },
        react_1.default.createElement(Card_1.default.Body, null,
            react_1.default.createElement(Row_1.default, null,
                react_1.default.createElement(Col_1.default, { xs: 6 },
                    react_1.default.createElement(Form_1.default.Group, { className: "mb-0" },
                        react_1.default.createElement(Form_1.default.Label, null, "Buchungsstatus"),
                        react_1.default.createElement(Form_1.default.Control, { className: "pl-1 pr-1", as: "select", value: props.booking.status.name, onChange: (e) => {
                                const status = BookingStatus_1.BookingStatus.fromName(e.target.value);
                                props.onBookingChange({
                                    status,
                                });
                            }, disabled: !props.editable },
                            react_1.default.createElement("option", { value: BookingStatus_1.BookingStatus.provisional.name }, BookingStatus_1.BookingStatus.provisional.nameDe),
                            react_1.default.createElement("option", { value: BookingStatus_1.BookingStatus.confirmed.name }, BookingStatus_1.BookingStatus.confirmed.nameDe),
                            react_1.default.createElement("option", { value: BookingStatus_1.BookingStatus.cancelled.name }, BookingStatus_1.BookingStatus.cancelled.nameDe)))),
                react_1.default.createElement(Col_1.default, { xs: 6 },
                    react_1.default.createElement("dl", null,
                        react_1.default.createElement("dt", null, "Rechnungsstatus"),
                        react_1.default.createElement("dd", { className: "mt-2 mb-0" },
                            react_1.default.createElement(Badge_1.default, { variant: "dark", className: `status-${props.booking.invoiceStatus.name}-bg` }, props.booking.invoiceStatus.nameDe)))))),
        modal));
};
exports.StatusCard = StatusCard;
